// extracted by mini-css-extract-plugin
var _1 = "ReportMobile__attemptsTitle--YlsQp";
var _2 = "ReportMobile__bestTitle--I308p";
var _3 = "ReportMobile__body--c_tPS";
var _4 = "ReportMobile__bodyContent--v3vdo";
var _5 = "ReportMobile__bodyContentSplit--PTVWp ReportMobile__bodyContent--v3vdo";
var _6 = "ReportMobile__bodyContentWrap--gisxP ReportMobile__bodyContent--v3vdo";
var _7 = "ReportMobile__bodyTitle--LGSCq";
var _8 = "ReportMobile__header--rcTJ7";
var _9 = "ReportMobile__headerTitle--exFdr";
var _a = "ReportMobile__item--muGzF";
var _b = "ReportMobile__name--LDS3d";
var _c = "ReportMobile__nameLong--qK86U";
var _d = "ReportMobile__namePlain--QTR3E";
var _e = "ReportMobile__played--UPcnj";
var _f = "ReportMobile__stars--A1wL8";
var _10 = "ReportMobile__statSummary--zgKhW";
var _11 = "ReportMobile__stats--x8DHE";
var _12 = "ReportMobile__timeItem--mS2Bu";
var _13 = "ReportMobile__timeLabel--MECAD";
var _14 = "ReportMobile__timeOuter--dcMa9";
var _15 = "ReportMobile__top--VAJhk";
export { _1 as "attemptsTitle", _2 as "bestTitle", _3 as "body", _4 as "bodyContent", _5 as "bodyContentSplit", _6 as "bodyContentWrap", _7 as "bodyTitle", _8 as "header", _9 as "headerTitle", _a as "item", _b as "name", _c as "nameLong", _d as "namePlain", _e as "played", _f as "stars", _10 as "statSummary", _11 as "stats", _12 as "timeItem", _13 as "timeLabel", _14 as "timeOuter", _15 as "top" }
